
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class MicrosoftTenantModel extends Model<MicrosoftTenantModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'companyId', type: 'string' },
		{ name: 'tenantId', type: 'number' },
		{ name: 'msCustomerTenantId', type: 'string' }
	];
	[key: string]: any;
	
	public companyId?: string;
	public tenantId: number;
	public msCustomerTenantId?: string;
    
	constructor(){
		super();
		this.companyId = undefined;
		this.tenantId = 0;
		this.msCustomerTenantId = undefined;
		
	}
	getProperties(){
		return MicrosoftTenantModel.classProperties;
	}
}

